import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../../../selectors';
import UiActions from '../../../actions/ui';
import OrderActions from '../../../actions/order';
import strings from '../../../strings';
import ModalBase from '../Base';
import { Icon } from '@mgc/react-components';

class ExcelValidationFailedModal extends Component {
    static propTypes = {
        // functions
        cancel: PropTypes.func.isRequired,
        downloadFailedExcel: PropTypes.func.isRequired,
        modalVisible: PropTypes.bool.isRequired,
        failedError: PropTypes.object,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            modalVisible: selectors.ui.getFailedValidationModalVisible,
            failedError: selectors.configurations.getExcelErrorMessageDataObj,
        });

    static mapDispatch = (dispatch, ownProps) => ({
        cancel: () => dispatch(UiActions.closeFailedValidationModal()),
        // downloadFailedExcel: () => dispatch(OrderActions.submitExcelOrder()),
        downloadFailedExcel: (fileData) =>
            dispatch(
                OrderActions.downloadConfigurationProductListWithErrors(
                    fileData
                )
            ),
    });

    _handleCancelClick() {
        this.props.cancel();
    }

    _closeButtonClass() {
        return 'btn';
    }

    _renderContent() {
        return (
            <div>
                <p>
                    <small className="text-danger">
                        <Icon name="icon-warning" />
                    </small>
                    <br />
                    The file you uploaded failed validation. <br /> To fix the
                    problems: <br />
                    <span>- Download the validation errors</span>
                    <br />
                    <span>- Correct the errors in the downloaded file</span>
                    <br />
                    <span>- Upload the corrected file to try again</span>
                    <br />
                </p>
            </div>
        );
    }

    render() {
        return (
            <ModalBase
                modalClassName="checkout-modal"
                modalTitle={'Error Validation Failed'}
                visible={this.props.modalVisible}
                closeModal={() => this._handleCancelClick()}
            >
                {this._renderContent()}
                <span>&nbsp;</span>
                <div className="text-left">
                    <button
                        className="btn btn-primary"
                        onClick={() =>
                            this.props.downloadFailedExcel(
                                this.props.failedError
                            )
                        }
                        disabled={false}
                    >
                        {strings.downloadValidationErros}
                    </button>
                    <span>&nbsp;&nbsp;&nbsp;</span>
                    <button
                        className={`btn ${this._closeButtonClass()}`}
                        onClick={() => this._handleCancelClick()}
                        disabled={false}
                    >
                        {strings.cancel}
                    </button>
                </div>
            </ModalBase>
        );
    }
}

export default withRouter(attach(ExcelValidationFailedModal));



// WEBPACK FOOTER //
// ./app/components/Modals/ExcelValidationFailedModal/index.jsx